import styled from 'styled-components';
import Btn021 from '../Btn021';
import Btn020 from '../Btn020';

export const ElementWrapper = styled.div`
  border-top: 1px solid rgba(38, 50, 56, 0.12);
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px;
`;
export const OkButton = styled(Btn021)``;

export const CancelButton = styled(Btn020)``;
